// extracted by mini-css-extract-plugin
export default {"navBackground":"navigation_navBackground__yiJGl","logo":"navigation_logo__CJdQK"};